import { Button, Image, Text } from '@belong/ui';
import clsx from 'clsx';
import { useStore } from 'src/store';
import { pushModalSelector } from 'src/store/modal';
import styles from './rental-experience-cta.module.css';
import { RENTAL_EXPERIENCE_CTA_STRINGS } from './rental-experience-cta.strings';

const BENEFITS_ITEMS = [
  {
    icon: 'residents/benefits/support-chat.png',
    body: RENTAL_EXPERIENCE_CTA_STRINGS.stress_free,
  },
  {
    icon: 'residents/benefits/belong-medal.png',
    body: RENTAL_EXPERIENCE_CTA_STRINGS.standards,
  },
  {
    icon: 'residents/benefits/belong_app.png',
    body: RENTAL_EXPERIENCE_CTA_STRINGS.belong_app,
  },
];

export function RentalExperienceCta() {
  const pushModal = useStore(pushModalSelector);

  function handleLearnMoreClick() {
    pushModal({ type: 'BELONG_STANDARDS' });
  }
  return (
    <div
      className={clsx(
        'border-gray bg-light-gray px-sm py-xl sm:mb-3xl relative flex flex-col items-center rounded border border-solid text-center',
        styles.wrapper,
      )}
    >
      <div className="mb-sm px-xs">
        <Text as="span" className="text-h3-sm" fontWeight="semibold">
          {RENTAL_EXPERIENCE_CTA_STRINGS.title}
        </Text>
      </div>

      {BENEFITS_ITEMS.map((item, index) => (
        <div
          className="mb-lg flex w-full max-w-[342px]  flex-col  items-center justify-between"
          key={index}
        >
          <div className="w-button-large">
            <Image className="size-full" alt="" src={item.icon} />
          </div>
          <Text className="mt-sm px-sm w-full text-center" variant="p1">
            {item.body}
          </Text>
          {index === 1 && (
            <Button
              variant="text"
              onClick={handleLearnMoreClick}
              className="mt-xs text-p1"
            >
              Learn More
            </Button>
          )}
        </div>
      ))}
    </div>
  );
}
